import {  FaUser,FaPhone,FaFolderOpen, FaHome, FaLinkedin, FaTwitter,  FaGithub, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import stripe from "./components/pics/stripe.png";
import funden from "./components/pics/donate.png";
import colorgenerator from "./components/pics/colorgenerator.png";
import cocktail from "./components/pics/cocktail.png";
import video from "./components/pics/videoproject.png";
import numbers from "./components/pics/numbers.png";
import menu from "./components/pics/menu.png";
import scroll from "./components/pics/scroll.png";
import counter from "./components/pics/counter.png";
import navbar from "./components/pics/nav-bar.png";
import placeholder from "./components/pics/content-placeholder.png";
import namefilter from "./components/pics/name-filter.png";
export const Links = [
	{
		id: 1,
		name: "home",
		url: "#home",
		icon: <FaHome />,
	},
	{
		id: 2,
		name: "about",
		url: "#about",
		icon: <FaUser />,
	},
	{
		id: 3,
		name: "projects",
		url: "#projects",
		icon: <FaFolderOpen />,
	},
];
export const social = [
	{
		id: 4,
		url: "https://ibsalam24@gmail.com",
		icon: <FaEnvelope />,
	},
	{
		id: 5,
		url: "https://wa.link/60fz3t",
		icon: <FaWhatsapp />,
	},
	{
		id: 6,
		url: "tel:+2349096166142",
		icon: <FaPhone />,
	},
	{
		id: 1,
		url: "https://github.com/Ibro09",
		icon: <FaGithub />,
	},
	{
		id: 2,
		url: "https://twitter.com/__ibra_heem",
		icon: <FaTwitter />,
	},
	{
		id: 3,
		url: "https://www.linkedin.com/in/ibrahim-abdulsalami-597236232",
		icon: <FaLinkedin />,
	},
];
export const Project = [
	{
		id: 1,
		projectName: "stripe clone",
		skills: ["html,css,javascript,figma,react"],
		img: stripe,
		text: "this was a project that was inspired by stripe payment website",
		className: "Right",
		url: "https://stripeclones.netlify.app/",
	},
	{
		id: 2,
		projectName: "tints and shade",
		skills: ["html,css,javascript,react"],
		img: colorgenerator,
		text: "this project was created to generate tints and shades of your chosen color",
		className: "Left",
		url: "https://c0l0r-generat0r.netlify.app/",
	},
	{
		id: 3,
		projectName: "fund website",
		skills: ["html,css,javascript,bootstrap,jquery"],
		img: funden,
		text: "this website is a clone of a donation website.But was first designed with figma",
		className: "Right",
		url: "https://ibro09.github.io/latest-project/",
	},
	{
		id: 4,
		projectName: "coctails dB",
		skills: ["html,css,javascript,react"],
		img: cocktail,
		text: "this is a project made to imitate a coctail selling company",
		className: "Left",
		url: "https://the-cocktailsdb.netlify.app/",
	},
];
export const moreProject = [
	...Project,
	{
		id: 5,
		projectName: "video project",
		skills: ["html,css,javascript"],
		img: video,
		text: "this is a project that uses a video as its header . it has a pause and play button",
		className: "Right",
		url: "https://ibro09.github.io/video-project/",
	},
	{
		id: 6,
		projectName: "scroll",
		skills: ["html,css,javascript"],
		img: scroll,
		text: "this is a project used to create imitate a  smooth scroll",
		className: "Left",
		url: "https://ibro09.github.io/scroll-project/",
	},
	{
		id: 7,
		projectName: "menu",
		skills: ["html,css,javascript"],
		img: menu,
		text: "this is a menu's project made for a resturant for foods",
		className: "Right",
		url: "https://ibro09.github.io/menu-project/",
	},
	{
		id: 8,
		projectName: "number",
		skills: ["html,css,javascript,react"],
		img: numbers,
		text: "this is a project that counts numbers according to time",
		className: "Left",
		url: "https://ibro09.github.io/numbers-counter/",
	},
	{
		id: 9,
		projectName: "counter",
		skills: ["html,css,javascript,bootstrap"],
		img: counter,
		text: "this is a  project was created to be used to count numbers     ",
		className: "Right",
		url: "https://ibro09.github.io/counter/",
	},
	{
		id: 10,
		projectName: "placeholder",
		skills: ["html,css,javascript"],
		img: placeholder,
		text: "this is a preloader used by many popular companies ",
		className: "Left",
		url: "https://ibro09.github.io/content-placeholder/",
	},
	{
		id: 11,
		projectName: "navbar",
		skills: ["html,css,javascript,tailwind css"],
		img: navbar,
		text: "this is a project that was just designed and built as a navbar",
		className: "Right",
		url: "https://ibro09.github.io/nav-bar/",
	},
	{
		id: 12,
		projectName: "name filter",
		skills: ["html,css,javascript,tailwind css"],
		img: namefilter,
		text: "this is a project that filters names of various people ",
		className: "Left",
		url: "https://ibro09.github.io/name-filter/",
	},
];